module.exports = __webpack_public_path__ + "img/1716349417814-WhatsApp Image 2024-05-22 at 10.40.22.jpeg.73f04e7a.webp";